export default __webpack_public_path__ + "static/media/UniSansThinItalic.7c9961e2.otf";